import {Grid} from '@material-ui/core';
import React, {useEffect, useMemo, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";
import axios from "axios";
import __ from "lodash";

import {CheckboxEditor, FormDialog} from "../../../controls";

function getTripColour(tripState, isNew, colours, type, props, legType) {
  let textColor = "rgba(0,0,0,1)";
  let backgroundColor = "rgba(31, 216, 21, 0.6)";
  let status = tripState === 'DELETED' ? 'DELETED' : tripState === 'CANCELLED' ? 'CANCELLED' : isNew ? 'NEW' : 'CHANGED';
  const colourRow = __.findIndex(colours, { code: `${type} STATUS` });
  if (colours && colourRow > -1) {
    if (props.changed && tripState !== 'DELETED' && tripState !== 'CANCELLED') {
      const changedColorExists = __.has(colours[colourRow].value, 'CHANGED');
      if (changedColorExists) {
        backgroundColor = colours[colourRow].value['CHANGED'];
      }
    } else {
      if (tripState === "DELETED" || tripState === "CANCELLED") {
        textColor = "rgba(0,0,0,0.5)";
        backgroundColor = "rgba(0,0,0,0.1)";
      } else {
        const statusColorExists = __.has(colours[colourRow].value, tripState);
        if (statusColorExists && !(legType === "FERRY" && tripState === "SCHEDULED")) {
          backgroundColor = colours[colourRow].value[tripState];
        } else if (legType !== "FERRY") {
          const defaultColorExists = __.has(colours[colourRow].value, 'DEFAULT');
          if (defaultColorExists) backgroundColor = colours[colourRow].value['DEFAULT'];
        }
      }
    }
  }
  return { backgroundColor, textColor, status };
}
const ApplyConfirmationDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const apiSitePrefix = props.apiSitePrefix;
  const colours = props.colours;

  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    title: 'Apply Scratchpad Changes',
    scratchPadUser: null, 
    scratchPad: 0,
    canSave: false
  });

  const tripStates = useMemo(() => ({
    'DELETED': 'Deleted',
    'CANCELLED': 'Cancelled',
    'NEW': 'New',
    'CHANGED': 'Changed'
  }),[]);

  const tripStateColours = useMemo(() => ({
    'DELETED': {background: "rgba(0,0,0,0.1)", textColor: "rgba(0,0,0,0.5)"},
    'CANCELLED': {background: "rgba(0,0,0,0.1)", textColor: "rgba(0,0,0,0.5)"},
    'NEW': {background: "rgba(210,0,0,0.9)", textColor: "rgba(255,255,255,1)"},
    'CHANGED': {background: "rgba(20,90,100,0.9)", textColor: "rgba(255,255,255,1)"}
  }),[]);

  const TripLine = (props) => {
    const {data} = props;
    const {changed, aircraftChanged, deleted, new: isNew, type, aircraftReg, tripNo, airlineCode, flightNo, sta, std, originAirportCode, destinationAirportCode, scheduledDepartureTimeUtc, scheduledArrivalTimeUtc, tripState, legType} = data;

    let { backgroundColor, textColor, status } = getTripColour(tripState, isNew, colours, type, props, legType);

    return (
      <Grid item xs={12} checkChildren={true} style={{fontSize: 12}}>
        <div style={{display: "inline-block", width: 60, padding: 2}}>
          <div style={{display: "inline-block", width: 60, padding: 3, textAlign: "center", border: '1px solid #303030', backgroundColor, color: textColor, fontWeight: "bold", fontFamily: "verdana"}}>{airlineCode}{flightNo}</div>
        </div>
        <div style={{display: "inline-block", width: 65, padding: 5, paddingLeft: 15}}>{aircraftReg}</div>
        <div style={{display: "inline-block", width: 75, padding: 5}}>{moment.utc(scheduledDepartureTimeUtc).format('DD MMM YYYY')}</div>
        <div style={{display: "inline-block", width: 30, padding: 5}}>{moment.utc(scheduledDepartureTimeUtc).format('HH:mm')}</div>
        <div style={{display: "inline-block", width: 100, padding: 5, textAlign: "center", fontWeight: "bold"}}><div style={{display: "inline-block", border: "1px solid #303030", borderRadius: 8, width: 35}}>{originAirportCode}</div> - <div style={{display: "inline-block", border: "1px solid #303030", borderRadius: 8, width: 35}}>{destinationAirportCode}</div></div>
        <div style={{display: "inline-block", width: 75, padding: 5, textAlign: "right"}}>{moment.utc(scheduledArrivalTimeUtc).format('DD MMM YYYY')}</div>
        <div style={{display: "inline-block", width: 35, padding: 5}}>{moment.utc(scheduledArrivalTimeUtc).format('HH:mm')}</div>
        <div style={{display: "inline-block", width: 90, padding: 5, paddingRight: 15, textAlign: "right"}}>{tripNo}</div>
        <div style={{display: "inline-block", width: 65, padding: 3, textAlign: "center", border: '1px solid #303030', backgroundColor: tripStateColours[status]?.background , color: tripStateColours[status]?.textColor, fontWeight: "normal", fontFamily: "verdana"}}>{tripStates[status]}</div>        
        <div style={{display: "inline-block", width: 65, padding: 3, textAlign: "center"}}><CheckboxEditor id='selection' onChange={props.onChange} value={props.value} style={{padding: 0, margin: 0}} /></div>        
      </Grid>
    );
  };

  const MxLine = (props) => {
    const {data} = props;
    const {changed, type, aircraftReg, mxAirportCode, startCheckDate, endCheckDate, aircraftCheck, mxAircraftCheckInfo} = data;

    const backgroundColor = 'rgb(128,91,44)'; 
    const textColor = '#ffffff'; 
    const status = 'CHANGED';

    return (
      <Grid item xs={12} checkChildren={true} style={{fontSize: 12}}>
        <div style={{display: "inline-block", width: 60, padding: 2}}>
          <div style={{display: "inline-block", width: 60, padding: 3, textAlign: "center", border: '1px solid #303030', backgroundColor, color: textColor, fontWeight: "bold", fontFamily: "verdana"}}>{aircraftCheck}</div>
        </div>
        <div style={{display: "inline-block", width: 65, padding: 5, paddingLeft: 15}}>{aircraftReg}</div>
        <div style={{display: "inline-block", width: 75, padding: 5}}>{moment.utc(startCheckDate).format('DD MMM YYYY')}</div>
        <div style={{display: "inline-block", width: 30, padding: 5}}>{moment.utc(startCheckDate).format('HH:mm')}</div>
        <div style={{display: "inline-block", width: 100, padding: 5, textAlign: "center", fontWeight: "bold"}}><div style={{display: "inline-block", border: "1px solid #303030", borderRadius: 8, width: 35}}>{mxAirportCode}</div></div>
        <div style={{display: "inline-block", width: 75, padding: 5, textAlign: "right"}}>{moment.utc(endCheckDate).format('DD MMM YYYY')}</div>
        <div style={{display: "inline-block", width: 35, padding: 5}}>{moment.utc(endCheckDate).format('HH:mm')}</div>
        <div style={{display: "inline-block", width: 90, padding: 5, paddingRight: 15, textAlign: "right"}}>{mxAircraftCheckInfo}</div>
        <div style={{display: "inline-block", width: 65, padding: 3, textAlign: "center", border: '1px solid #303030', backgroundColor: tripStateColours[status]?.background , color: tripStateColours[status]?.textColor, fontWeight: "normal", fontFamily: "verdana"}}>{tripStates[status]}</div>        
        <div style={{display: "inline-block", width: 65, padding: 3, textAlign: "center"}}><CheckboxEditor onChange={props.onChange} value={props.value} style={{padding: 0, margin: 0}} /></div>        
      </Grid>
    );
  };

  const ScratchPadChanges = (props) => {
    const {record, changeRecord} = props;
    const {trips, scheduled, maintenance} = record;
    const selection = record.selection || {};

    const onChange=(uuid, value) => {
      let changedRecords = [];
      let tripNo = null;
      const trip = __.find(trips, {uuid: uuid});
      if (trip) {
        changedRecords = trips;
        tripNo = trip.tripNo;
      } else {
        const schedule = __.find(scheduled, {uuid: uuid});
        if (schedule) {
          changedRecords = scheduled;
          tripNo = schedule.tripNo;
        } else {
          const mx = __.find(maintenance, {uuid: uuid});
          if (mx) {
            changedRecords = maintenance;
          }
        }
      }

      if (changedRecords && tripNo) {
        for (let i = 0; i < changedRecords.length; i++) {
          if (changedRecords[i].tripNo === tripNo) {
            selection[changedRecords[i].uuid] = value;
          }
        }
      }
      selection[uuid] = value;
      const newRecord = {...record, selection};
      changeRecord(newRecord);
    }
    return (
      <Grid container checkChildren={false} spacing={3}>
        <Grid item xs={12} checkChildren={false}>
          {trips && trips.length > 0 &&
            trips.map(trip => <TripLine key={trip.uuid} data={trip} value={selection[trip.uuid]} onChange={(value)=>onChange(trip.uuid, value)}/>)
          }  
          {scheduled && scheduled.length > 0 &&
            scheduled.map(trip => <TripLine key={trip.uuid} data={trip} value={selection[trip.uuid]} onChange={(value)=>onChange(trip.uuid, value)}/>)
          }  
          {maintenance && maintenance.length > 0 &&
            maintenance.map(mx => <MxLine key={mx.uuid} data={mx} value={selection[mx.uuid]} onChange={(value)=>onChange(mx.uuid, value)}/>)
          }  
        </Grid>
      </Grid>
    )
  }

  const DisplayForm = () => {
     const copyToClipboard = (record) => {
      const htmlChanges = record.changesHtml;

      const tableStyles = `
        <style>
          table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
          }
          th {
            background-color: #eeeeee;
          }
          th, td {
            padding: 5px;
          }
          td.trip {
            font-weight: bold;
          }
        </style>
      `;

      const changes = htmlChanges.join('');
      const tableHeading = `<tr><th>Flight</th><th>Aircraft</th><th>STD</th><th>Route</th><th>STA</th><th>Trip No</th><th>Status</th></tr>`;
      const table = `${tableStyles}<table>${tableHeading}${changes}</table>`;

      const blob = new Blob([table], { type: 'text/html' });
      // eslint-disable-next-line no-undef
      const clipboardItem = new ClipboardItem({ 'text/html': blob });
      navigator.clipboard.write([clipboardItem]);
    }

    const buttons = dialogState.canSave ? {
      copyToClipboard:{icon: "copy", key: "Copy to Clipboard", label: "Copy to Clipboard", color: "primary"},
      save:{icon: "check_circle", key: "Update", label: "Apply Changes", color: "primary", disabled: (status)=>{return status.error}},
      cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
    } : {
      copyToClipboard:{icon: "copy", key: "Copy to Clipboard", label: "Copy to Clipboard", color: "primary"},
      cancel:{icon: "cancel", key: "Close", label: "Close", color: "primary"}
    }
      
    return (
      <FormDialog
        title={dialogState.title}
        message="Please review the below changes that will be made to the flight schedule."
        open={dialogState.showDialog}
        record={dialogState.record}
        dialogOptions={{width: "md", maxWidth: "md", fullWidth: false}}
        classes={classes}
        // validator={Validator}
        buttons = {buttons}
        onChange={(state) => {
          if (state.buttonPressed === "save" && dialogState.canSave) {
            eventBus.trigger('RouteView.applyScratchPad', {selection: state.record?.selection});
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null, scratchPadUser: null});
          } else if (state.buttonPressed === "copyToClipboard") {
            copyToClipboard(state.record);
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null, scratchPadUser: null});
          } else {
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null, scratchPadUser: null});
          }
        }}
      >
        {(record, changeRecord) => (
          <ScratchPadChanges id="selection" changeRecord={changeRecord} record={record} />        
        )}
      </FormDialog>
    )
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {scratchPadUser, scratchPad, canSave} = params;
      const title = canSave ? 'Apply Scratchpad Changes' : 'View Scratchpad Changes';
      
      const HtmlTripLine = (props) => {
        const {data} = props;
        const {new: isNew, type, aircraftReg, tripNo, airlineCode, flightNo, originAirportCode, destinationAirportCode, scheduledDepartureTimeUtc, scheduledArrivalTimeUtc, tripState, legType} = data;
    
        let { backgroundColor, textColor, status } = getTripColour(tripState, isNew, colours, type, props, legType);
        console.log(tripStateColours);
    
        return `<tr><td style="font-weight: bold; background-color: ${backgroundColor}; color: ${textColor};">${airlineCode}${flightNo}</td><td>${aircraftReg}</td><td>${moment.utc(scheduledDepartureTimeUtc).format('DD MMM YYYY HH:mm')}</td><td>${originAirportCode} - ${destinationAirportCode}</td><td>${moment.utc(scheduledArrivalTimeUtc).format('DD MMM YYYY HH:mm')}</td><td>${tripNo}</td><td style="background-color: ${tripStateColours[status]?.background}; color: ${tripStateColours[status]?.textColor};">${tripStates[status]}</td></tr>`;
      };

      const HtmlMxLine = (props) => {
        const {data} = props;
        const {aircraftReg, tripNo, mxAirportCode, startCheckDate, endCheckDate, aircraftCheck, mxAircraftCheckInfo} = data;
    
        const backgroundColor = 'rgb(128,91,44)'; 
        const textColor = '#ffffff'; 
        const status = 'CHANGED';
    
        return `<tr><td style="font-weight: bold; background-color: ${backgroundColor}; color: ${textColor};">${aircraftCheck}</td><td>${aircraftReg}</td><td>${moment.utc(startCheckDate).format('DD MMM YYYY HH:mm')}</td><td>${mxAirportCode}</td><td>${moment.utc(endCheckDate).format('DD MMM YYYY HH:mm')}</td><td>${mxAircraftCheckInfo}</td><td>${tripNo}</td><td style="background-color: ${tripStateColours[status]?.background}; color: ${tripStateColours[status]?.textColor};">${tripStates[status]}</td></tr>`;
      };

      axios.get(
        `${apiSitePrefix}/schedulingscratchpads/list/${scratchPadUser}`
      ).then((response) => {
        const {data: scratchPads} = response;
        const record = {trips:[], scheduled:[], maintenance:[], selection:{}, changesHtml:[]};
        if (scratchPadUser && scratchPads && Array.isArray(scratchPads)) {
          let deltas = {...scratchPads[scratchPad].deltas};
          if (deltas) {
            const {updated} = deltas;   

            if (updated) {
              record['trips'] = updated.trips || [];
              record['scheduled'] = updated.scheduled || [];
              record['maintenance'] = updated.maintenance || [];
              for (const trip of record.trips) {
                record.selection[trip.uuid] = true;
                record.changesHtml.push(HtmlTripLine({data:trip}));
              }
              for (const trip of record.scheduled) {
                record.selection[trip.uuid] = true;
                record.changesHtml.push(HtmlTripLine({data:trip}));
              }
              for (const mx of record.maintenance) {
                record.selection[mx.uuid] = true;
                record.changesHtml.push(HtmlMxLine({data:mx}));
              }
            }
          }
        }
        setDialogState({...dialogState, showDialog:true, scratchPadUser, scratchPad, canSave, title, record});
      });
    }
    eventBus.bind("ApplyConfirmationDialog.open", open);
    return () => {
      eventBus.unbind("ApplyConfirmationDialog.open", open);
    }
  }, [apiSitePrefix, colours, dialogState, eventBus, tripStateColours, tripStates]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default ApplyConfirmationDialog;


